<H1>Login!</H1>

<div class="container">
  <div class="alert alert-warning" *ngIf='invalidLogin'>{{errorMessage}}</div>

  <form>
    <fieldset class="form-group">
      <label>User Name </label>
      <input type="text" name="username" class="form-control" [(ngModel)]="username">
    </fieldset>
    <fieldset class="form-group">
      <label>Password </label>
      <input type="password" name="password" class="form-control" [(ngModel)]="password">
    </fieldset>

    <button (click)=handleLoginhc() class="btn btn-primary mr-1">Hardcoded Login</button>
    <button (click)=handleAWSCognitoLogin() class="btn btn-success mr-1">Login with Cognito</button>
    <!--http://localhost:4200 url-->
    <!--<a href="https://infosetb2c.b2clogin.com/infosetb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_todo-signin&client_id=edc46ef6-69cf-4fd1-88b6-d62dac478c7c&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2F&scope=openid&response_type=id_token&prompt=login"
      class="btn btn-success mr-1">Azure Login</a> -->
    <a href="https://infosetb2c.b2clogin.com/infosetb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_todo-signin&client_id=edc46ef6-69cf-4fd1-88b6-d62dac478c7c&nonce=defaultNonce&redirect_uri=https%3A%2F%2Ftodofunctionappfotis.z22.web.core.windows.net%2F&scope=openid&response_type=id_token&prompt=login" 
     class="btn btn-success mr-1">Azure Login</a> 

  </form>
</div>